// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.travel-line {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.field-label {
  font-weight: bold;
  margin-right: 0.5rem;
}

p-inputSwitch {
  margin-left: 0.5rem;
}

input[type=email] {
  margin-left: 0.5rem;
  width: 24rem;
}

form .travel-line + div .travel-line {
  padding-left: 0;
  margin-top: 0.75rem;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlYXNzaWduLXB1cmNoYXNlLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0kscUJBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7QUFDSjs7QUFFQTtFQUNJLGlCQUFBO0VBQ0Esb0JBQUE7QUFDSjs7QUFFQTtFQUNJLG1CQUFBO0FBQ0o7O0FBRUE7RUFDSSxtQkFBQTtFQUNBLFlBQUE7QUFDSjs7QUFFQTtFQUNJLGVBQUE7RUFDQSxtQkFBQTtBQUNKIiwiZmlsZSI6InJlYXNzaWduLXB1cmNoYXNlLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRyYXZlbC1saW5lIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwLjVyZW07XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuXG4uZmllbGQtbGFiZWwge1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICAgIG1hcmdpbi1yaWdodDogMC41cmVtO1xufVxuXG5wLWlucHV0U3dpdGNoIHtcbiAgICBtYXJnaW4tbGVmdDogMC41cmVtO1xufVxuXG5pbnB1dFt0eXBlPVwiZW1haWxcIl0ge1xuICAgIG1hcmdpbi1sZWZ0OiAwLjVyZW07XG4gICAgd2lkdGg6IDI0cmVtO1xufVxuXG5mb3JtIC50cmF2ZWwtbGluZStkaXYgLnRyYXZlbC1saW5lIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDA7XG4gICAgbWFyZ2luLXRvcDogMC43NXJlbTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/components/reassign-purchase/reassign-purchase.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;AACA,w8BAAw8B","sourcesContent":[".travel-line {\n    margin-bottom: 0.5rem;\n    display: flex;\n    align-items: center;\n}\n\n.field-label {\n    font-weight: bold;\n    margin-right: 0.5rem;\n}\n\np-inputSwitch {\n    margin-left: 0.5rem;\n}\n\ninput[type=\"email\"] {\n    margin-left: 0.5rem;\n    width: 24rem;\n}\n\nform .travel-line+div .travel-line {\n    padding-left: 0;\n    margin-top: 0.75rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
